/**
 * <urgency-bar> — the shrinking "only X% left" bar (P7; live shipped it
 * minified inside the custom.js webpack bundle — behaviour kept 1:1:
 * sessionStorage-keyed start time, hourly shrink rate re-derived on load,
 * a 30-second tick shrinking toward 1%).
 */
if (!customElements.get('urgency-bar')) {
  class UrgencyBar extends HTMLElement {
    connectedCallback() {
      requestAnimationFrame(() => this.setup());
    }

    disconnectedCallback() {
      if (this.shrinkInterval) clearInterval(this.shrinkInterval);
    }

    setup() {
      this.startPercent = parseInt(this.dataset.startPercent, 10) || 30;
      this.shrinkRate = parseFloat(this.dataset.shrinkRate) || 5;
      this.storageKey = this.dataset.storageKey || 'urgency-default';
      this.fill = this.querySelector('.urgency-bar__fill');
      this.percentElement = this.querySelector('.urgency-bar__percent');

      const stored = this.getStored();
      if (!stored) {
        this.setStored({ startTime: Date.now() });
        this.render(this.startPercent);
        this.startShrinking(this.startPercent);
        return;
      }
      const hoursElapsed = (Date.now() - stored.startTime) / 3600000;
      const percent = Math.max(1, this.startPercent - hoursElapsed * this.shrinkRate);
      this.render(percent);
      this.startShrinking(percent);
    }

    render(percent) {
      const rounded = Math.round(percent);
      if (this.fill) this.fill.style.width = `${100 - rounded}%`;
      if (this.percentElement) this.percentElement.textContent = `${rounded}%`;
    }

    startShrinking(fromPercent) {
      let current = fromPercent;
      this.shrinkInterval = setInterval(() => {
        current -= this.shrinkRate / 120;
        if (current <= 1) {
          current = 1;
          clearInterval(this.shrinkInterval);
        }
        this.render(current);
      }, 30000);
    }

    getStored() {
      try {
        return JSON.parse(sessionStorage.getItem(this.storageKey));
      } catch (error) {
        return null;
      }
    }

    setStored(value) {
      try {
        sessionStorage.setItem(this.storageKey, JSON.stringify(value));
      } catch (error) {
        /* storage unavailable — the bar simply restarts per page */
      }
    }
  }

  customElements.define('urgency-bar', UrgencyBar);
}
